import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useQuery = () => {
    const { search } = useLocation();
    return new URLSearchParams(search);
};

export const useUpdateQueryParams = () => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const updateQueryParams = useCallback(
        (paramsToUpdate: Record<string, string | null>) => {
            const params = new URLSearchParams(search);
            Object.entries(paramsToUpdate).forEach(([key, value]) => {
                if (value !== null) {
                    params.set(key, value);
                } else {
                    params.delete(key);
                }
            });

            const newSearch = params.toString();
            navigate(`${pathname}${newSearch ? `?${newSearch}` : ''}`, { replace: true });
        },
        [navigate, pathname, search]
    );

    return updateQueryParams;
};
